module.exports = __webpack_public_path__ + "media/images/plans/plan-icon-guest-book-8aba80172c3176da83008840cfc71dfa.png";